import React, { useEffect, useRef } from "react";
import moment from "moment";
import { useReactToPrint } from "react-to-print";
import { getDate } from "utils/formatDate";
import { formatNumber } from "utils/currencyFormat";

const XuatExcelTatToan = ({
  show,
  onHide,
  listData,
  totals,
  isPrint = false,
}) => {
  const printRef = useRef();
  const handleDownload = () => {
    const table = document.getElementById("tblExcelTatToan");
    if (!table) return;

    const uri =
      "data:application/vnd.ms-excel;charset=utf-8,%EF%BB%BF" +
      encodeURIComponent(table.outerHTML);

    const link = document.createElement("a");
    link.href = uri;
    link.download = `DanhSachTatToan_${moment().format(
      "DD-MM-YYYY_HHmmss",
    )}.xls`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    if (onHide) onHide();
  };
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: `DanhSachTatToan_${moment().format("DD-MM-YYYY_HHmmss")}`,
    onAfterPrint: onHide,
  });
  useEffect(() => {
    if (show && listData?.length > 0) {
      const timeout = setTimeout(() => {
        const printNode = printRef.current;
        if (!printNode) return;

        // Hiện tạm nội dung để ReactToPrint có thể truy cập được
        printNode.style.visibility = "visible";
        printNode.style.position = "static";

        if (isPrint) {
          handlePrint();
        } else {
          handleDownload();
        }

        // Ẩn lại sau khi in xong (chờ một chút)
        setTimeout(() => {
          printNode.style.visibility = "hidden";
          printNode.style.position = "absolute";
          printNode.style.top = "-9999px";
          printNode.style.left = "-9999px";
        }, 1500);
      }, 500);

      return () => clearTimeout(timeout);
    }
  }, [show, listData, isPrint]);

  const tongBanGhi = listData?.length || 0;
  const tongTienVay = totals?.TotalSoTienVay ?? 0;
  const tongTienPhaiTra = totals?.TotalSoTienPhaiTatToan ?? 0;
  const tongTienDaTra = totals?.TotalSoTienDaTatToan ?? 0;
  const tongChenhLech = totals?.TotalChenhLech ?? 0;

  if (!show) return null;
  return (
    <>
      <div
        ref={printRef}
        id="tblExcelTatToan"
        style={{
          position: "absolute",
          top: "-9999px",
          left: "-9999px",
          visibility: "hidden",
        }}
      >
        <table
          border="1"
          className="table-bordered"
          style={{
            borderCollapse: "collapse",
            width: "100%",
            fontFamily: "Arial",
            fontSize: "13px",
            color: "#000",
          }}
        >
          <thead>
            <tr>
              <th
                colSpan="9"
                style={{
                  fontSize: "18px",
                  borderBottom: "0px solid #000",
                  borderRight: "0px solid #000",
                  borderTop: "0px solid #000",
                  textAlign: "center",
                  padding: "8px 0",
                }}
              >
                Danh sách tất toán
              </th>
            </tr>

            <tr style={{ backgroundColor: "#f2f2f2" }}>
              <th>
                STT
                <br />
                <span>[ {tongBanGhi} ]</span>
              </th>
              <th>Ngày giao dịch</th>
              <th>Nhân viên</th>
              <th>Tên khách hàng</th>
              <th>Mã hợp đồng</th>
              <th>
                Số tiền vay <br />{" "}
                <span>= {formatNumber(Math.round(tongTienVay))}</span>
              </th>
              <th>
                Số tiền phải tất toán <br />{" "}
                <span>= {formatNumber(Math.round(tongTienPhaiTra))}</span>
              </th>
              <th>
                Số tiền đã tất toán <br />{" "}
                <span>= {formatNumber(Math.round(tongTienDaTra))}</span>
              </th>
              <th>
                Chênh lệch <br />{" "}
                <span>= {formatNumber(Math.round(tongChenhLech))}</span>
              </th>
            </tr>
          </thead>

          <tbody>
            {listData?.map((item, idx) => (
              <tr key={idx}>
                <td style={{ textAlign: "center" }}>{idx + 1}</td>
                <td style={{ textAlign: "left" }}>{getDate(item.Time)}</td>
                <td>{item.Name}</td>
                <td>
                  {item.nameCus}
                  <br />
                  SĐT:{item.Phone?.toString()}
                </td>
                <td>{item.Code}</td>
                <td style={{ textAlign: "right" }}>
                  {formatNumber(Math.round(item.Sotienvay ?? 0))}
                </td>
                <td style={{ textAlign: "right" }}>
                  {formatNumber(Math.round(item.TienPhaiTatToan ?? 0))}
                </td>
                <td style={{ textAlign: "right" }}>
                  {formatNumber(Math.round(item.TongTien ?? 0))}
                </td>
                <td style={{ textAlign: "right" }}>
                  {formatNumber(Math.round(item.ChenhLech ?? 0))}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <style>
          {`
              .table-bordered th, .table-bordered td {
                border: 1px solid #000;
                padding: 5px;
                vertical-align: top;
              }
              .table-bordered th {
                background-color: #e8f5e9;
              }
              .table-bordered {
                border: 1px solid #000;
              }
            `}
        </style>
      </div>
    </>
  );
};

export default XuatExcelTatToan;
